module.exports = __webpack_public_path__ + "static/media/hs_4k.8ec726a1.jpg";